import { FC, useRef, useState, useEffect } from 'react';
import { useWindowSize } from 'utils/hooks';
import { ProductImageGalleryProps, Styled } from './';

const ProductImageGallery: FC<ProductImageGalleryProps> = ({ images }) => {
  const { isXs } = useWindowSize();
  const [ImageGallery, setImageGallery] = useState<any>(null);

  useEffect(() => {
    const loadImageGallery = async () => {
      const imageGalleryModule = await import('react-image-gallery');
      setImageGallery(() => imageGalleryModule.default);
    };
    loadImageGallery();
  }, []);

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // To support video formats.
  const videoTypeMap = new Map([
    ['.mp4', 'video/mp4'],
    ['.webm', 'video/webm'],
    ['.ogg', 'video/ogg'],
  ]);

  const getVideoType = (url: string) => {
    const ext = Array.from(videoTypeMap.keys()).find(ext =>
      url.toLowerCase().endsWith(ext)
    );
    return ext ? videoTypeMap.get(ext) : null;
  };

  const galleryItems = images.map((image, index) => {
    const videoType = getVideoType(image.original);
    if (videoType) {
      return {
        ...image,
        renderItem: () => (
          <div className="video-wrapper">
            <video
              ref={el => {
                if (index === activeIndex) videoRef.current = el;
              }}
              controls
              width="100%"
              muted
              loop
            >
              <source src={image.original} type={videoType} />
              Your browser does not support the video tag.
            </video>
          </div>
        ),
      };
    }
    return image;
  });

  const handleSlideChange = (currentIndex: number) => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    setActiveIndex(currentIndex);
  };

  return (
    <Styled.ProductImageGalleryWrapper>
      {ImageGallery && (
        <ImageGallery
          items={galleryItems}
          showFullscreenButton={false}
          showPlayButton={false}
          showNav={isXs}
          thumbnailPosition={isXs ? 'bottom' : 'left'}
          lazyLoad
          showThumbnails={!isXs}
          onSlide={handleSlideChange}
          startIndex={activeIndex}
        />
      )}
    </Styled.ProductImageGalleryWrapper>
  );
};

export default ProductImageGallery;
